
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { DateHelper } from "@rivtn/noseur";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IHostWebsite, IMember } from "../../../../../services";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { DASHBOARD_URL, hostLogo, isPageVisible, pagePath, visiblePages } from "../../helpers";

export interface FooterProps {
    basePath: string;
    profile?: IMember;
    website: IHostWebsite;
}

function Footer({ website, basePath, profile }: FooterProps) {

    const labels = i18nManager.Labels.footer;
    const mainLabels = globalI18nManager.Labels;
    const year = DateHelper.getStartOfDay().getFullYear();
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const search = searchParams.toString();
    const owner = website.owns_copyright ? website.host.name : mainLabels.omnehost;
    const socials = Object.entries(website.owns_copyright ? (website.social_accounts ?? {}) : { ...Utils.OMNEHOST_SOCIALS, ...(website.social_accounts ?? {}) });
    const logo = hostLogo(website);

    return (<footer className={styles["cta-footer"]}>
        <section className={styles["cta"]}>
            <div className={styles["container"]}>
                <div className={styles["cta-inner"]}>
                    <span className={styles["h-05"]}>{labels.cta}</span>
                    <ReactRouterDom.NavLink to={{ pathname: `/${basePath}`, search }} className={styles["cta-logo"]}>
                        {logo ? (<img src={logo} alt={website.host.name} />) : (<span className={styles["h-02"]}>{website.host.name}</span>)}
                    </ReactRouterDom.NavLink>
                    {isPageVisible(website, "TOURNAMENTS") && (<Btn to={{ pathname: pagePath(basePath, "TOURNAMENTS"), search }}>{labels.cta_button}</Btn>)}
                    <nav className={styles["footer-nav"]}>
                        {visiblePages(website).map(([page, pageSettings]) => (
                            <ReactRouterDom.NavLink key={page} end to={{ pathname: pagePath(basePath, page), search }}>{pageSettings.label}</ReactRouterDom.NavLink>
                        ))}
                    </nav>
                </div>
            </div>
        </section>

        <section className={styles["footer"]}>
            <div className={styles["container"]}>
                <span className={styles["footer-brand"]}>{website.host.name}</span>
                <div className={styles["footer-inner"]}>
                    <span className={styles["footer-muted"]}>© {year} {owner}. {labels.rights}</span>
                    <div className={styles["footer-socials"]}>
                        {socials.map(([social, username]) => (
                            <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username as string)} aria-label={social} className={styles["social-btn"]}>
                                <i className={Utils.getSocialIcon(social) ?? "fa fa-link"} />
                            </ReactRouterDom.NavLink>
                        ))}
                    </div>
                    {!website.owns_copyright && (<div className={styles["footer-links"]}>
                        <a target="_blank" rel="noreferrer" href={DASHBOARD_URL}>{profile ? mainLabels.auth.dashboard : mainLabels.auth.sign_in}</a>
                        {mainLabels.footer.map((f) => (<a key={f.label} target="_blank" rel="noreferrer" href={f.location}>{f.label}</a>))}
                    </div>)}
                </div>
            </div>
        </section>
    </footer>);
}

export default Footer;
